import { useRef } from 'react';
import { editorStore, useEditorStore } from './editorStore';
import { Icon } from '../components/ui/Icon';

export default function MediaLibrary() {
  const { siteId, assets, pendingImageTarget } = useEditorStore();
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const assetList = Object.values(assets);

  return (
    <div className="media-library">
      <div className="media-library-header">
        <h3>Media</h3>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/png,image/jpeg,image/webp,image/gif,image/svg+xml"
          hidden
          onChange={(event) => {
            const file = event.target.files?.[0];
            if (file) {
              void editorStore.uploadAsset(file);
            }
            event.target.value = '';
          }}
        />
        <button
          type="button"
          className="media-library-upload"
          onClick={() => fileInputRef.current?.click()}
        >
          <Icon name="upload" size={15} />
          Upload image
        </button>
      </div>

      {assetList.length === 0 ? (
        <div className="media-library-empty">
          No images yet. Upload one to use it in the site.
        </div>
      ) : (
        <div className="media-library-grid">
          {assetList.map((asset) => (
            <div className="media-library-item" key={asset.assetId}>
              <img src={asset.url} alt={asset.alt || 'Site image'} />
              <input
                type="text"
                value={asset.alt}
                maxLength={120}
                placeholder="Alt text"
                onChange={(event) => editorStore.updateAssetAlt(asset.assetId, event.target.value)}
              />
              {pendingImageTarget ? (
                <button
                  type="button"
                  className="inspector-image-button"
                  onClick={() => editorStore.applyAsset(asset)}
                  disabled={pendingImageTarget.blockId !== siteId}
                >
                  Use this image
                </button>
              ) : (
                <span className="media-library-size">
                  {asset.width && asset.height ? `${asset.width}×${asset.height}` : ''}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
